import { validateStringInput } from '../utils/formValidationHelpers';

export interface ContactTag {
    tagId: number;
    tag: string;
}

export type TagFlag = 'assigned' | 'unassigned';

export type ContactTagWithFlag = ContactTag & {
    flag: TagFlag;
};

export type SectionTag = {
    assigned: ContactTagWithFlag[];
    unassigned: ContactTagWithFlag[];
};

export interface CreateContactTagRequest {
    contactId?: number;
    tagId?: number;
    isPublic: boolean;
    tag: string;
}

export interface UpdateContactTagRequest {
    tag: string;
}

/**
 * buildCreateContactTag
 *
 * @description
 * Builds an object which matches that expected by the server for a request to
 * create a new contact tag object.
 */
export function buildCreateContactTag(args: {
    tag: string;
    isPublic?: boolean;
    contactId?: number;
}): CreateContactTagRequest {
    return {
        tag: validateStringInput('tag', args.tag),
        isPublic: args.isPublic !== undefined ? args.isPublic : true,
        contactId: args.contactId,
    };
}
